<template>
    <div class="register-section my-12 py-12">
        <v-card color="primary" class="pa-9">
          <v-card-title class="text-center white--text justify-center font-weight-bold"><div v-html="$t('home.registration.title')"></div></v-card-title>
          <v-card-subtitle class="pt-6 d-flex justify-center">
            <v-btn color="white" class="primary--text mx-auto px-12" large to="/cadastrar"><div v-html="$t('home.registration.cta')"></div></v-btn>
          </v-card-subtitle>
        </v-card>
    </div>
</template>
<script>
export default {
    name: "CoverSection"
}
</script>